// Training/Service entity model
export interface TrainingService {
  id: string
  serviceType: ServiceType
  startTime: Date
  endTime: Date
  breakDuration: number // in minutes
  description: string
  specialNotes: string
  requiresProtocol: boolean
  trainingType: TrainingType
  assignedUserId: string
  projectId: string
  createdBy: string
  createdAt: Date
  updatedAt: Date
  status: ServiceStatus
}
export enum ServiceType {
  HALF_DAY_MORNING = 'Halve dag (ochtend)',
  HALF_DAY_AFTERNOON = 'Halve dag (middag)',
  HALF_DAY_EVENING = 'Halve dag (avond)',
  FULL_DAY = 'Hele dag',
  CUSTOM = 'Aangepast',
}
export enum TrainingType {
  OWT = 'OWT',
  DRIVING_STYLE = 'Rijstijl',
  SLIPTRAINING = 'Sliptraining',
  DEFENSIVE_DRIVING = 'Defensief Rijden',
  CODE_95 = 'Code 95',
  EMERGENCY_RESPONSE = 'Calamiteitentraining',
  OTHER = 'Overig',
}
export enum ServiceStatus {
  PLANNED = 'Gepland',
  CONFIRMED = 'Bevestigd',
  IN_PROGRESS = 'In uitvoering',
  COMPLETED = 'Afgerond',
  CANCELLED = 'Geannuleerd',
}
